<script lang="ts">
	import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
	//Services
	import { format } from 'svelte-i18n';
	import { get } from 'svelte/store';
	//Components
	import SelectList from 'src/components/SelectList/SelectList.svelte';

	//Stores
	import { devices } from 'src/stores/lists/devices';
	import { rooms } from 'src/stores/lists/rooms';
	//Helpers
	import { sortByPosition } from 'src/components/Lists/list-helpers';
	import { selectDevicesByRoom } from '../../../../../GenericComponents/helpers';
	import {
		excludedCategoriesFromWhenConditions,
		excludedDeviceTypesFromWhenConditions,
	} from 'src/components/Scenes/helpers/init_device_conditions';
	import { getDeviceMathProps } from 'src/components/Scenes/helpers/math_based/math_param_utils';
	// Types
	import { createEventDispatcher } from 'svelte';
	import { real_id } from 'src/helpers/interface_helpers';
	import { includedDeviceTypesForDoActions } from 'src/components/Scenes/helpers/init_device_actions';

	//Constants
	const exclude_categories = excludedCategoriesFromWhenConditions;
	const exclude_types = excludedDeviceTypesFromWhenConditions;
	const exclude_shared = true;

	export let selectedDevice: { id: string } = null;
	export const selectedProperty: string = null;

	const dispatch = createEventDispatcher();
	const _devices = get(devices);
	const _devices_status = get(devices_status);
	const _devices_settings = get(devices_settings);

	//Filter the supported-only devices are shown in the room-devices list
	const filterDevices = (device): boolean => {
		//Show only supported by Math Scenes devices
		let supportedProps = getDeviceMathProps(
			_devices?.[device.id],
			_devices_status?.[real_id(device.id)],
			_devices_settings?.[real_id(device.id)],
		);
		if (supportedProps && supportedProps.length > 0) {
			// console.log('Device Has supported Math Param properties: ', supportedProps);
			return true;
		}

		return false;
	};

	// Prepare the list of devices in each room
	$: devicesList = Object.values({
		...$rooms,
	})
		.sort(sortByPosition)
		.map((room: any) => {
			let _room = { title: room.name, value: room.id };
			let roomDevices = selectDevicesByRoom(
				$devices,
				_room,
				exclude_categories,
				exclude_types,
				exclude_shared,
			)
				.filter(filterDevices) //Show only PM devices
				.sort(sortByPosition);
			return {
				roomID: room.id,
				roomName: room.name,
				cards: roomDevices,
			};
		})
		.filter((room) => {
			return room.cards.length > 0;
		})
		.map(prepareRoomDevicesList);

	const prepareRoomDevicesList = (room) => {
		const updatedCards = room.cards.map((device) => {
			let device_item = device;
			return {
				...device_item,
				selected: device.id === selectedDevice?.id,
			};
		});

		return {
			...room,
			cards: updatedCards,
		};
	};

	const handleSelect = (selected) => {
		dispatch('selectDevice', selected);
	};
</script>

<SelectList
	class="mb-m"
	title={$format('label_select_device', {
		default: 'Select device',
	})}
	list={devicesList}
	variant="radio"
	selectedCardsId={selectedDevice ? [selectedDevice] : []}
	on:click={(e) => handleSelect(e.detail)}
/>
